import { createSlice } from "@reduxjs/toolkit";
import {
  forwardEmailQueueStatus,
  IIntegrationPartner,
} from "../../interfaces/interfaces";

const INITIAL_STATE = {
  isCredentialValid: true,
  credentialError: "",
  brands: [],
  integrationPartner: {} as any,
  isConnectionHubOpen: false,
  openConnectionHub: false,
  forwardEmailQueue: {} as any,
};

const credentialVerification = createSlice({
  name: "credentialVerification",
  initialState: INITIAL_STATE,
  reducers: {
    updateCredentialVerificationDetails: (state, action) => {
      console.log("Setting ", action);
      state.isCredentialValid = action.payload.isCredentialValid;
      state.credentialError = action.payload.credentialError;
      state.brands = action.payload.brands;
      state.integrationPartner = action.payload.integrationPartner;
      state.isConnectionHubOpen = action.payload.isConnectionHubOpen;
    },
    clearCrendentialVerificationDetails: (state) => {
      console.log("setting state", INITIAL_STATE);
      state.isCredentialValid = INITIAL_STATE.isCredentialValid;
      state.credentialError = INITIAL_STATE.credentialError;
      state.openConnectionHub = INITIAL_STATE.openConnectionHub;
    },
    changeConnectionHubState: (state, action) => {
      console.log("Opening", action.payload.open);
      state.openConnectionHub = action.payload.open;
    },
    updateForwardEmailQueue: (state, action) => {
      const { email, jobDetails } = action.payload;
      const existingJobDetails = state?.forwardEmailQueue?.[email]
        ? { ...state?.forwardEmailQueue?.[email]["jobDetails"] }
        : {};
      state.forwardEmailQueue = {
        ...state.forwardEmailQueue,
        [email]: {
          ...existingJobDetails,
          ...jobDetails,
        },
      };
    },
    deleteForwardEmailQueue: (state, action) => {
      const { email } = action.payload;
      if (state.forwardEmailQueue[email]) {
        delete state.forwardEmailQueue[email];
      }
    },
  },
});

export const {
  updateCredentialVerificationDetails,
  clearCrendentialVerificationDetails,
  changeConnectionHubState,
  updateForwardEmailQueue,
  deleteForwardEmailQueue,
} = credentialVerification.actions;

export const credentialVerificationReducer = credentialVerification?.reducer;
